import React, { createContext, useContext } from 'react'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import { AxiosResponse } from 'axios'
import { UseQueryResult } from 'react-query'
import { tsLimsOwner, tsLimsSampleType } from '../../Typescript/StuartPy/Lims'
import { Box } from '@mui/material'
import { drawer } from '../../garvan-react/Constants/StyleConstants'
import DrawerConfig from '../../DrawerMenus/DrawerConfig'
import { usePyGet } from '../../APIs/Hooks/PyAPIHooks'
import { useGetCodeSet } from '../../APIs/Hooks/CodeSetHooks'
import { tsCodeSetValue } from '../../Typescript/API_Response'
import { useBioBankMenuItems } from '../../DrawerMenus/MenuItems/BioBankMenu'

interface BioBankContextType {
  sampleTypeQuery: UseQueryResult<tsLimsSampleType[], AxiosResponse<any, any>>
  ownersQuery: UseQueryResult<tsLimsOwner[], AxiosResponse<any, any>>
  statusQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  descriptorQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
}

const BioBankContext = createContext<BioBankContextType>(
  {} as BioBankContextType,
)
export const useBioBankContext = () => useContext(BioBankContext)

function BioBankModule({ children }: { children: any }) {
  const sampleTypeQuery = usePyGet(['/lims/sample_types'])
  const ownersQuery = usePyGet(['/lims/owners'])
  const statusQuery = useGetCodeSet('TissueIssueStatusID')
  const descriptorQuery = useGetCodeSet('SampleDescriptorID')
  const menuItems = useBioBankMenuItems()
  return (
    <BioBankContext.Provider
      value={{
        sampleTypeQuery,
        ownersQuery,
        statusQuery,
        descriptorQuery,
      }}
    >
      <Box
        sx={{
          width: 1,
          pl: drawer / 10,
          pr: { xl: drawer / 10 }, //center if enough space
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <DrawerConfig itemsInit={menuItems} />
        {children}
      </Box>
    </BioBankContext.Provider>
  )
}

export default BioBankModule
